import React, { FC, useEffect } from 'react';
import './PrizesPage.scss';

import { ItvGenericPage } from '../ItvGenericPage';
import { useUserContext } from '../../../providers/UserProvider';
import { BRANDS } from '../../../components/Itv/types';

export const PrizesPage: FC = () => {
  const { setTheme } = useUserContext();

  useEffect(() => {
    setTheme(BRANDS.PRIZES);
  }, []);

  return <ItvGenericPage variant="prizes" />;
};
